export default __webpack_public_path__ + "static/media/the-sprint-team.d0c44fa5.svg";